import { render } from "./SciencePage.vue?vue&type=template&id=2690d79a&scoped=true"
import script from "./SciencePage.vue?vue&type=script&lang=js"
export * from "./SciencePage.vue?vue&type=script&lang=js"

import "./SciencePage.vue?vue&type=style&index=0&id=2690d79a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2690d79a"]])

export default __exports__